











import { defineComponent, toRefs } from '@vue/composition-api';
import CollectFileBrowser from '@/renderer/views/browser/collect/components/CollectFile.vue';
import CollectFileMobile from '@/renderer/views/mobile/collect/components/CollectFile.vue';
import { InviteTitleData } from '@/renderer/views/common/collect/index.vue';

export default defineComponent({
  name: 'CollectFile',
  props: {
    collectToken: {
      type: String,
      require: true,
      default: '',
    },
  },
  components: { CollectFileBrowser, CollectFileMobile },
  setup(props, context) {
    const methods = {
      setInviteTitle(inviteTitleData: InviteTitleData) {
        context.emit('setInviteTitle', inviteTitleData);
      },
    };
    return {
      ...methods,
    };
  },
});
